/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_Section_Reading_RateInputs */



/**
* | output |
* | --- |
* | "Reading Rate" |
*
* @param {Options_Metrics_Section_Reading_RateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_section_reading_rate = /** @type {((inputs?: Options_Metrics_Section_Reading_RateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_Section_Reading_RateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reading Rate")
	if (locale === "de") return /** @type {LocalizedString} */ ("Reading Rate")
	if (locale === "it") return /** @type {LocalizedString} */ ("Reading Rate")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Reading Rate")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reading Rate")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Reading Rate")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Reading Rate")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Reading Rate")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Reading Rate")
	return /** @type {LocalizedString} */ ("Reading Rate")
});